import { render, staticRenderFns } from "./ListProductCard.vue?vue&type=template&id=24353065"
import script from "./ListProductCard.vue?vue&type=script&lang=js"
export * from "./ListProductCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports